import { ActionTypes } from "../../constants/ActionTypes";
import { IFolderReducer } from "../../interfaces/Folder";

const INIT_STATE: IFolderReducer = {
    letterFolderList: [],
    searchText: ""
};

export default (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case ActionTypes.GET_LETTERFOLDER_LIST: {
            return {
                ...state,
                searchText: action.payload
            };
        }

        case ActionTypes.FETCH_LETTERFOLDER_LIST_SUCCESS: {
            return {
                ...state,
                letterFolderList: action.payload,
            };
        }


        default:
            return state;
    }
};
